import { connect } from 'react-redux';
import EditPanel from './EditPanel';
import {
  editSupplierAuthorizationDetails,
  fetchSupplierAuthorizationDetails,
  getSupplierAuthorizationDetails,
  setDialogDetails,
  setForceCloseEditDrawer,
  toggleSupplierAuthActivation,
} from '../store/supplierAuthorizationSlice';

const mapState = state => ({
  details: getSupplierAuthorizationDetails(state),
  dialogDetails: state.loadingManagement.supplierAuthorizations.dialogDetails,
});

const mapDispatch = {
  editSupplierAuthorizationDetails,
  fetchDetails: fetchSupplierAuthorizationDetails,
  setDialogDetails,
  setForceCloseEditDrawer,
  toggleSupplierAuthActivation,
};

export default connect(mapState, mapDispatch)(EditPanel);
